// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currency-select {
  -webkit-appearance: none;
  -moz-appearance: none /* デフォルトのスタイルを無効 */;
       appearance: none /* デフォルトのスタイルを無効 */;
  background-position: right 10px center;
  background-repeat: no-repeat;
  background-size: 12px 9px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.main-select {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.arrow {
  padding: 5px 6px 0 1px;
}

@media (max-width: 767px) {
  .arrow {
    padding: 0 6px 0 4px;
  }
}

.open_indicator {
  margin-right: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
}

[role='combobox'] {
  border: 1px solid var(--outline-primary-color);
  border-radius: 999px;
  padding: 0 2px 0 0;
  background: var(--surface-secondary-background-color);
  height: 100%;
}

button[aria-expanded='true'] {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[role='combobox'] span {
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
}

[role='listbox'] {
  border: 1px solid var(--outline-primary-color);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background: var(--surface-primary-background-color);
  margin-top: -6px;
}

[role='listbox'] li {
  padding: 3px 8px 3px 1px;
  transition: 0.1s;
  background: var(--surface-primary-background-color);
}

[role='listbox'] li:hover {
  transition: 0.1s;
  background: var(--surface-hover-secondary-color);
}

#currency-select {
  position: absolute;
}

#currency-select [role='listbox'] {
  width: 100%;
  min-width: 0px !important;
}

.network-search {
  overflow-y: scroll;
}

.network-search::-webkit-scrollbar {
  width: 8px;
}

.network-search::-webkit-scrollbar-track {
  background: var(--text-inactive-color);
  border-radius: var(--corner-radius-100);
}

.network-search::-webkit-scrollbar-thumb {
  background: var(--surface-tertiary-background-color);
  border-radius: var(--corner-radius-100);
  width: 4px;
  margin: 0 auto;
}

.network-token-search {
  overflow-y: scroll;
  padding-right: 8px; /* スクロールバー分の余白を確保 */
  box-sizing: border-box;
}

.network-token-search::-webkit-scrollbar {
  width: 8px; /* 外枠の幅 */
}

.network-token-search::-webkit-scrollbar-track {
  background: var(--surface-inactive-background-color);
  border-radius: var(--corner-radius-100);
}

.network-token-search::-webkit-scrollbar-thumb {
  background-color: var(--surface-secondary-background-color);
  border-radius: var(--corner-radius-100);
  border: 2px solid transparent; /* 外枠との間に余白を作る */
  background-clip: content-box; /* content-box にすることで、内側を 4px に */
}`, "",{"version":3,"sources":["webpack://./src/domain/main/select.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yCAAoC;OAApC,oCAAoC;EACpC,sCAAsC;EACtC,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,oDAAoD;EACpD,uCAAuC;EACvC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB,EAAE,mBAAmB;EACvC,sBAAsB;AACxB;;AAEA;EACE,UAAU,EAAE,SAAS;AACvB;;AAEA;EACE,oDAAoD;EACpD,uCAAuC;AACzC;;AAEA;EACE,2DAA2D;EAC3D,uCAAuC;EACvC,6BAA6B,EAAE,gBAAgB;EAC/C,4BAA4B,EAAE,iCAAiC;AACjE","sourcesContent":[".currency-select {\n  -webkit-appearance: none;\n  appearance: none /* デフォルトのスタイルを無効 */;\n  background-position: right 10px center;\n  background-repeat: no-repeat;\n  background-size: 12px 9px;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.main-select {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.arrow {\n  padding: 5px 6px 0 1px;\n}\n\n@media (max-width: 767px) {\n  .arrow {\n    padding: 0 6px 0 4px;\n  }\n}\n\n.open_indicator {\n  margin-right: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 12px;\n}\n\n[role='combobox'] {\n  border: 1px solid var(--outline-primary-color);\n  border-radius: 999px;\n  padding: 0 2px 0 0;\n  background: var(--surface-secondary-background-color);\n  height: 100%;\n}\n\nbutton[aria-expanded='true'] {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n[role='combobox'] span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n}\n\n[role='listbox'] {\n  border: 1px solid var(--outline-primary-color);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  background: var(--surface-primary-background-color);\n  margin-top: -6px;\n}\n\n[role='listbox'] li {\n  padding: 3px 8px 3px 1px;\n  transition: 0.1s;\n  background: var(--surface-primary-background-color);\n}\n\n[role='listbox'] li:hover {\n  transition: 0.1s;\n  background: var(--surface-hover-secondary-color);\n}\n\n#currency-select {\n  position: absolute;\n}\n\n#currency-select [role='listbox'] {\n  width: 100%;\n  min-width: 0px !important;\n}\n\n.network-search {\n  overflow-y: scroll;\n}\n\n.network-search::-webkit-scrollbar {\n  width: 8px;\n}\n\n.network-search::-webkit-scrollbar-track {\n  background: var(--text-inactive-color);\n  border-radius: var(--corner-radius-100);\n}\n\n.network-search::-webkit-scrollbar-thumb {\n  background: var(--surface-tertiary-background-color);\n  border-radius: var(--corner-radius-100);\n  width: 4px;\n  margin: 0 auto;\n}\n\n.network-token-search {\n  overflow-y: scroll;\n  padding-right: 8px; /* スクロールバー分の余白を確保 */\n  box-sizing: border-box;\n}\n\n.network-token-search::-webkit-scrollbar {\n  width: 8px; /* 外枠の幅 */\n}\n\n.network-token-search::-webkit-scrollbar-track {\n  background: var(--surface-inactive-background-color);\n  border-radius: var(--corner-radius-100);\n}\n\n.network-token-search::-webkit-scrollbar-thumb {\n  background-color: var(--surface-secondary-background-color);\n  border-radius: var(--corner-radius-100);\n  border: 2px solid transparent; /* 外枠との間に余白を作る */\n  background-clip: content-box; /* content-box にすることで、内側を 4px に */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
